import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthService } from './auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(private authService: AuthService) {}
  title = 'rozie-care-insights-dashboard';

  ngOnInit() {
    this.authService.handleAuthCallback();
  }
}
